import { createTheme, ThemeProvider, Typography } from "@mui/material";
import Box from "@mui/material/Box";

const theme = createTheme({
  typography: {
    // fontFamily: ["Elza Trial", "Regular"].join(","),
  },
});

/**
 * Subtitle component.
 *
 * This component renders a styled subtitle with a specified text and optional custom styles.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {string} props.text - The text content of the subtitle.
 * @param {object} [props.sx] - Custom style overrides using the `sx` prop from MUI (optional).
 *
 * @returns {JSX.Element} - The JSX element for the styled subtitle.
 */
function Subtitle({ text, sx }) {
  return (
    <Box sx={sx}>
      <ThemeProvider theme={theme}>
        <Box>
          <Typography
            variant="subtitle2"
            gutterBottom
            sx={{
              fontWeight: 500,
              mb: 1,
              ...sx,
            }}
          >
            {text}
          </Typography>
        </Box>
      </ThemeProvider>
    </Box>
  );
}

export default Subtitle;
